import './index.css';
import ReactDOM from 'react-dom';
import Projects from './Components/body.jsx';

// ReactDOM.render(<Projects/>,document.getElementById('projects'))
const container = document.getElementById('projects');
const root = ReactDOM.createRoot(container); 
root.render(<Projects/>);